// ========================= 片库送审 - 平台状态 =========================
// 平台审核状态枚举值（1-已上线，2-已通过，3-未通过，4-审核中，5-待提审）
export const PlatformAuditStatusOnline     = 1  // 已上线
export const PlatformAuditStatusPassed     = 2  // 已通过 - 成功
export const PlatformAuditStatusFailed     = 3  // 未通过 - 失败
export const PlatformAuditStatusProcessing = 4  // 审核中 - 进行中
export const PlatformAuditStatusPending    = 5  // 待提审

// 平台审核状态文案和颜色
export const PlatformAuditStatusList = [
  { value: PlatformAuditStatusOnline,     text: '已上线', color: '#52c41a' },
  { value: PlatformAuditStatusPassed,     text: '成功', color: '#1677ff' },
  { value: PlatformAuditStatusFailed,     text: '失败', color: '#ff4d4f' },
  { value: PlatformAuditStatusProcessing, text: '进行中', color: '#8c8c8c' },
  { value: PlatformAuditStatusPending,    text: '待提审', color: '#bfbfbf' },
]

// ========================= 片库送审 - 平台 Key 枚举 =========================
export const PlatformKeyUc         = 'uc'           // UC
export const PlatformKeyZfb        = 'zfb'          // 支付宝
export const PlatformKeyMg         = 'mg'           // Migu
export const PlatformKeyKs         = 'ks'           // 快手自建站
export const PlatformKeyAqy        = 'aqy'          // 爱奇艺
export const PlatformKeyBjh        = 'bjh'          // 百家号
export const PlatformKeyTb         = 'tb'           // Taobao
export const PlatformKeyYk         = 'yk'           // 优酷
export const PlatformKeyTx         = 'tx'           // 腾讯视频
export const PlatformKeyHw         = 'hw'           // 华为

// ========================= 片库送审 - 平台列表 =========================
// 平台列表（key 对应接口字段前缀，可根据后端实际字段修改）
export const ThirdPlatformList = [
  { key: PlatformKeyUc,  text: 'UC',        idField: 'uc_drama_id',         statusField: 'uc_audit_status',         msgField: 'uc_audit_msg'         },
  { key: PlatformKeyZfb, text: '支付宝',    idField: 'zfb_drama_id',        statusField: 'zfb_audit_status',        msgField: 'zfb_audit_msg'        },
  { key: PlatformKeyMg,  text: '咪咕',      idField: 'mg_drama_id',         statusField: 'mg_audit_status',         msgField: 'mg_audit_msg'         },
  // { key: PlatformKeyKs,  text: '快手自建站', idField: 'ks_drama_id',         statusField: 'ks_audit_status',         msgField: 'ks_audit_msg'         },
  // { key: PlatformKeyAqy, text: '爱奇艺',    idField: 'aqy_drama_id',        statusField: 'aqy_audit_status',        msgField: 'aqy_audit_msg'        },
  // { key: PlatformKeyBjh, text: '百家号',    idField: 'bjh_drama_id',        statusField: 'bjh_audit_status',        msgField: 'bjh_audit_msg'        },
  // { key: PlatformKeyTb,  text: 'Taobao',    idField: 'tb_drama_id',         statusField: 'tb_audit_status',         msgField: 'tb_audit_msg'         },
  // { key: PlatformKeyYk,  text: '优酷',      idField: 'yk_drama_id',         statusField: 'yk_audit_status',         msgField: 'yk_audit_msg'         },
  // { key: PlatformKeyTx,  text: '腾讯视频',  idField: 'tx_drama_id',         statusField: 'tx_audit_status',         msgField: 'tx_audit_msg'         },
  // { key: PlatformKeyHw,  text: '华为',      idField: 'hw_drama_id',         statusField: 'hw_audit_status',         msgField: 'hw_audit_msg'         },
]

// ========================= UC 编辑 - 是否免费 =========================
export const UcIsFreeOptions = [
  { value: 1, text: '仅免费' },
  { value: 2, text: '免费或会员都可以' },
  { value: 3, text: '仅会员' },
]

// ========================= UC 编辑 - 下拉数据源 =========================
// 分类
export const UcCategory = ['都市', '古风', '现言', '民国', '古言']
// 主线
export const UcZhuxianTags = ['修真', '玄幻', '异能', '家庭', '穿越', '重生', '职场', '灵异', '末日', '校园', '民俗', '乡村', '都市', '古装', '情感', '年代', '恋爱']
// 角色
export const UcJueseTags = ['战神', '兵王', '神豪', '神医', '赘婿', '总裁', '大女主', '霸总', '萌宝', '替身', '白月光', '天才', '小狼狗', '商人', '弃妇', '大佬', '绿茶', '仙妖', '神魔', '农民', '婆媳', '女强', '僵尸', '小人物', '保安', '保镖', '女婿', '打工人', '宠妻', '偏执', '美女', '女总裁', '外卖', '偶像明星', '腹黑', '病娇']
// 情节
export const UcQingjieTags = ['闪婚', '娱乐圈', '复仇', '世家', '鉴宝', '逆袭', '商战', '异界', '豪门', '古穿今', '马甲', '宫斗', '宅斗', '家庭伦理', '女配逆袭', '古代情缘', '悬疑恐怖', '破镜重圆', '先婚后爱', '强者归来', '爱恨情仇', '虐渣打脸', '家长里短', '扮猪吃虎', '高手下山', '契约婚姻', '相爱相杀', '升级', '豪门世家', '年下', '伦理', '失忆', '医术', '民国', '创业', '带球跑', '金手指', '青梅竹马', '权谋']
// 风格
export const UcFenggeTags = ['热血', '虐恋', '甜宠', '爽文', '暧昧', '轻松', '正剧', '励志', '反转', '脑洞']

// ========================= UC 编辑 - 漫剧类型 =========================
// 漫剧二级分类（值用 code，展示用 desc）
export const UcGenreSecTypes = [
  { code: 1001, desc: 'AI真人演绎剧' },
  { code: 1002, desc: 'AI真人解说剧' },
  { code: 1003, desc: '解说漫' },
  { code: 1004, desc: '2D动态漫' },
  { code: 1005, desc: '3D动态漫' },
  { code: 1006, desc: '表情包与沙雕漫' },
  { code: 1007, desc: '其他' },
]

// ========================= 剧集类型枚举 =========================
export const DramaTypeManhua   = 1  // 漫剧
export const DramaTypeZhenren  = 2  // 真人剧
export const DramaTypeDigital  = 3  // 数字真人（按漫剧处理）

// 判断是否为漫剧（drama_type: 2=真人，非2=漫剧）
export function isManhuaDrama(dramaType) {
  return dramaType != null && dramaType !== DramaTypeZhenren
}

// 素材 DramaType 转 UC GenreType（2→"0"真人，非2→"10"漫剧）
export function dramaTypeToGenreType(dramaType) {
  return dramaType === DramaTypeZhenren ? '0' : '10'
}

// ========================= 支付宝编辑 - 标签数据源 =========================
export const ZfbTagList = ['打脸虐渣','古风权谋','现代','阴差阳错','团宠','欢喜冤家','青梅竹马','破镜重圆','权谋','成长','职场','校园','小人物','亲情','乡村','暗恋','言情','追妻','豪门恩怨','历史架空','励志','系统','强者回归','穿书','替身','经典影视合集','女频','男频','奇幻','种田','战神','真假千金','末世','扮猪吃老虎','重生','宅斗','宫廷','大女主','创业','搞笑','游戏','二次元','影视','vlog','美妆','情感','教育','体育','短剧','娱乐','政务号','颜值','音乐','旅行','全部','时尚','汽车','美食','家庭','异能','逆袭','赘婿','复仇','仙侠','虐恋','甜宠','悬疑','先婚后爱','神豪','萌宝','民国','古风']
